export const reportsList = [
  {
    id: 'REP-2023-001',
    title: 'Aktivitas Mencurigakan di Pelabuhan',
    type: 'Kejadian',
    category: 'Keamanan',
    urgency: 'Tinggi',
    sender: 'P-001',
    region: 'DKI Jakarta',
    time: '2023-10-27 14:30:00',
    status: 'Diverifikasi',
    stage: 'Diverifikasi',
    unit: 'Operasi Lapangan',
    binda: 'BINDA DKI Jakarta',
    provinsi: 'DKI Jakarta',
    kabupaten: 'Jakarta Utara',
    kecamatan: 'Tanjung Priok',
    ringkasan:
      'Terpantau aktivitas bongkar-muat di luar jam operasional resmi pada Terminal Peti Kemas Tanjung Priok. Sekelompok individu tidak berseragam memindahkan sejumlah kontainer ke truk tanpa dokumen manifes yang sah, diduga terkait penyelundupan barang terlarang.',
    kronologi:
      '02:15 — Personel lapangan mendeteksi tiga truk memasuki area dermaga 3 tanpa registrasi gerbang.\n02:40 — Enam individu menurunkan muatan dari kontainer berkode CMAU-7741XX.\n03:05 — Truk meninggalkan area menuju Jl. Cilincing Raya.\n03:20 — Pengamatan dihentikan untuk menghindari kontak; dokumentasi foto diamankan.',
    pihakTerkait:
      'Operator terminal swasta, dua perusahaan ekspedisi tidak terdaftar, serta oknum petugas keamanan internal pelabuhan.',
    potensiDampak:
      'Potensi masuknya barang ilegal ke jalur distribusi nasional, kerugian penerimaan negara, serta indikasi keterlibatan jaringan terorganisir di simpul logistik vital.',
    rekomendasiAwal:
      'Lakukan koordinasi dengan Bea Cukai dan otoritas pelabuhan untuk audit manifes kontainer CMAU-7741XX, intensifkan pemantauan CCTV dermaga 3 pada jam 00:00–04:00, serta identifikasi pemilik tiga truk melalui pelat nomor terdokumentasi.',
    attachments: [
      { name: 'foto_dermaga_01.jpg', kind: 'foto' },
      { name: 'foto_kontainer.jpg', kind: 'foto' },
      { name: 'catatan_lapangan.pdf', kind: 'dokumen' },
    ],
    geotag: {
      lat: -6.1045,
      lng: 106.8806,
      label: 'Terminal Peti Kemas Tanjung Priok',
    },
  },
  {
    id: 'REP-2023-002',
    title: 'Rencana Pengumpulan Massa',
    type: 'Informasi',
    category: 'Sosial',
    urgency: 'Sedang',
    sender: 'P-002',
    region: 'Jawa Barat',
    time: '2023-10-27 13:15:22',
    status: 'Belum Diverifikasi',
    stage: 'Dikirim',
    unit: 'Pengumpulan HUMINT',
    binda: 'BINDA Jawa Barat',
    provinsi: 'Jawa Barat',
    kabupaten: 'Kota Bandung',
    kecamatan: 'Coblong',
    ringkasan:
      'Beredar ajakan melalui kanal media sosial tertutup untuk pengumpulan massa di sekitar Gedung Sate pada akhir pekan, dengan estimasi 500–800 peserta menuntut isu ketenagakerjaan.',
    kronologi:
      'Pagi — Tertangkap unggahan ajakan di grup percakapan dengan 1.200 anggota.\nSiang — Beberapa akun mulai menyebarkan poster digital titik kumpul.\nSore — Koordinator lapangan diidentifikasi mengatur logistik transportasi.',
    pihakTerkait:
      'Aliansi serikat pekerja lokal dan beberapa organisasi mahasiswa.',
    potensiDampak:
      'Gangguan lalu lintas pusat kota, potensi gesekan dengan aparat bila tidak terkoordinasi, serta eskalasi tuntutan ke isu politik.',
    rekomendasiAwal:
      'Verifikasi keabsahan izin kegiatan, lakukan pendekatan dialogis dengan koordinator, dan siapkan rekayasa lalu lintas antisipatif.',
    attachments: [{ name: 'tangkapan_layar_ajakan.jpg', kind: 'foto' }],
    geotag: { lat: -6.9025, lng: 107.6186, label: 'Gedung Sate, Bandung' },
  },
  {
    id: 'REP-2023-003',
    title: 'Ancaman Siber Terdeteksi',
    type: 'Darurat',
    category: 'Siber',
    urgency: 'Kritis',
    sender: 'P-003',
    region: 'Nasional',
    time: '2023-10-27 12:00:05',
    status: 'Ditindaklanjuti',
    stage: 'Tindak Lanjut',
    unit: 'Analisis Siber',
    binda: 'Pusat Analisis Nasional',
    provinsi: 'DKI Jakarta',
    kabupaten: 'Jakarta Pusat',
    kecamatan: 'Gambir',
    ringkasan:
      'Terdeteksi upaya intrusi terkoordinasi terhadap infrastruktur layanan publik berbasis cloud. Pola serangan menunjukkan karakteristik Advanced Persistent Threat (APT) dengan eksfiltrasi data terenkripsi.',
    kronologi:
      '11:10 — Lonjakan trafik tidak wajar dari blok IP asing terdeteksi sensor.\n11:35 — Percobaan brute-force pada gateway autentikasi gagal 14.000 kali.\n11:52 — Terdeteksi satu sesi anomali berhasil menembus lapisan pertama.\n12:00 — Sistem diisolasi dan tim respons insiden diaktifkan.',
    pihakTerkait:
      'Aktor ancaman tak teridentifikasi (diduga kelompok APT lintas negara), penyedia layanan cloud nasional.',
    potensiDampak:
      'Kebocoran data warga skala besar, gangguan layanan publik kritikal, serta risiko reputasi keamanan siber nasional.',
    rekomendasiAwal:
      'Aktifkan protokol isolasi penuh, rotasi seluruh kredensial, lakukan forensik digital pada sesi anomali, dan koordinasikan dengan BSSN untuk pemblokiran blok IP sumber.',
    attachments: [
      { name: 'log_intrusi.txt', kind: 'dokumen' },
      { name: 'analisis_paket.pdf', kind: 'dokumen' },
    ],
    geotag: {
      lat: -6.1751,
      lng: 106.8272,
      label: 'Pusat Data Nasional, Jakarta',
    },
  },
  {
    id: 'REP-2023-004',
    title: 'Patroli Rutin',
    type: 'Harian',
    category: 'Keamanan',
    urgency: 'Rendah',
    sender: 'P-004',
    region: 'Bali',
    time: '2023-10-27 10:45:10',
    status: 'Selesai',
    stage: 'Selesai',
    unit: 'Pengawasan Wilayah',
    binda: 'BINDA Bali',
    provinsi: 'Bali',
    kabupaten: 'Kota Denpasar',
    kecamatan: 'Denpasar Selatan',
    ringkasan:
      'Patroli rutin pengamanan kawasan wisata Sanur berjalan kondusif. Tidak ditemukan aktivitas mencurigakan; arus wisatawan dalam batas normal.',
    kronologi:
      '08:00 — Mulai patroli dari Posko Sanur.\n09:15 — Pemeriksaan titik keramaian Pantai Sanur, situasi aman.\n10:30 — Koordinasi dengan pengamanan hotel setempat.\n10:45 — Patroli selesai, kembali ke posko.',
    pihakTerkait: 'Pengelola kawasan wisata, pengamanan hotel mitra.',
    potensiDampak:
      'Tidak ada potensi dampak signifikan. Situasi dinilai aman terkendali.',
    rekomendasiAwal:
      'Pertahankan frekuensi patroli harian, tingkatkan kewaspadaan pada akhir pekan saat lonjakan kunjungan.',
    attachments: [{ name: 'log_patroli_sanur.pdf', kind: 'dokumen' }],
    geotag: {
      lat: -8.6878,
      lng: 115.2626,
      label: 'Kawasan Wisata Sanur, Denpasar',
    },
  },
  {
    id: 'REP-2023-005',
    title: 'Drone Tidak Dikenal',
    type: 'Cepat',
    category: 'Keamanan',
    urgency: 'Tinggi',
    sender: 'P-005',
    region: 'Papua',
    time: '2023-10-27 09:30:00',
    status: 'Belum Diverifikasi',
    stage: 'Draft',
    unit: 'Reaksi Cepat',
    binda: 'BINDA Papua',
    provinsi: 'Papua',
    kabupaten: 'Kota Jayapura',
    kecamatan: 'Jayapura Utara',
    ringkasan:
      'Terpantau sebuah wahana udara nirawak (drone) berukuran sedang melintasi area terbatas dekat instalasi strategis tanpa izin penerbangan yang tercatat.',
    kronologi:
      '09:10 — Drone pertama kali terlihat dari pos pengamatan ketinggian.\n09:20 — Wahana berputar dua kali di atas perimeter instalasi.\n09:30 — Drone menghilang ke arah perbukitan sebelum dapat diidentifikasi operatornya.',
    pihakTerkait: 'Operator drone tidak teridentifikasi.',
    potensiDampak:
      'Potensi pengintaian instalasi strategis, risiko keamanan perimeter, dan kemungkinan pemetaan oleh pihak tidak bertanggung jawab.',
    rekomendasiAwal:
      'Aktifkan sistem deteksi anti-drone, tingkatkan pengamanan perimeter udara, dan telusuri rekaman radar untuk jejak lintasan wahana.',
    attachments: [{ name: 'foto_drone_jauh.jpg', kind: 'foto' }],
    geotag: {
      lat: -2.5337,
      lng: 140.7181,
      label: 'Perimeter Instalasi, Jayapura',
    },
  },
  {
    id: 'REP-2023-006',
    title: 'Upaya Sabotase Infrastruktur',
    type: 'Darurat',
    category: 'Objek Vital Nasional',
    urgency: 'Kritis',
    sender: 'P-012',
    region: 'Jawa Tengah',
    time: '2023-10-26 22:15:00',
    status: 'Ditindaklanjuti',
    stage: 'Analisis',
    unit: 'Pengamanan Objek Vital',
    binda: 'BINDA Jawa Tengah',
    provinsi: 'Jawa Tengah',
    kabupaten: 'Kabupaten Cilacap',
    kecamatan: 'Cilacap Tengah',
    ringkasan:
      'Ditemukan indikasi upaya sabotase pada jaringan pasokan bahan bakar di kilang Cilacap. Sebuah katup pengaman ditemukan dirusak sengaja serta terdapat jejak penyusupan di pagar perimeter sektor timur.',
    kronologi:
      '21:30 — Sensor tekanan pipa mendeteksi anomali penurunan mendadak.\n21:50 — Tim teknis menemukan katup KV-12 dalam kondisi dirusak.\n22:05 — Ditemukan bekas potongan pada pagar perimeter sektor timur.\n22:15 — Area diamankan dan laporan darurat dikirim.',
    pihakTerkait:
      'Pelaku penyusupan tidak teridentifikasi, diduga jaringan terorganisir dengan pengetahuan teknis instalasi.',
    potensiDampak:
      'Potensi gangguan pasokan bahan bakar nasional, risiko kebakaran/ledakan, serta ancaman terhadap objek vital nasional.',
    rekomendasiAwal:
      'Tingkatkan status pengamanan objek vital ke level tertinggi, lakukan sweeping menyeluruh perimeter, periksa rekaman CCTV 24 jam terakhir, dan koordinasikan dengan manajemen kilang untuk audit sistem keselamatan.',
    attachments: [
      { name: 'foto_katup_rusak.jpg', kind: 'foto' },
      { name: 'foto_pagar_perimeter.jpg', kind: 'foto' },
      { name: 'laporan_teknis_kilang.pdf', kind: 'dokumen' },
    ],
    geotag: {
      lat: -7.7333,
      lng: 109.0167,
      label: 'Kilang Cilacap, Jawa Tengah',
    },
  },
]

export const personnelList = [
  {
    id: 'OP-772',
    name: 'Agen Alpha',
    role: 'Personel Lapangan',
    region: 'DKI Jakarta',
    status: 'Aktif',
    clearance: 'Tingkat 3',
  },
  {
    id: 'OP-891',
    name: 'Agen Bravo',
    role: 'Personel Lapangan',
    region: 'Jawa Barat',
    status: 'Aktif',
    clearance: 'Tingkat 3',
  },
  {
    id: 'AN-102',
    name: 'Analis Charlie',
    role: 'Analis',
    region: 'Markas Besar',
    status: 'Aktif',
    clearance: 'Tingkat 4',
  },
  {
    id: 'OP-445',
    name: 'Agen Delta',
    role: 'Personel Lapangan',
    region: 'Papua',
    status: 'Luring',
    clearance: 'Tingkat 3',
  },
  {
    id: 'KB-001',
    name: 'Direktur Echo',
    role: 'Kepala BINDA',
    region: 'Bali',
    status: 'Aktif',
    clearance: 'Tingkat 5',
  },
]

export const alertsList = [
  {
    id: 'ALT-001',
    type: 'KRITIS',
    source: 'SIGINT',
    location: 'DKI Jakarta',
    time: '2 mnt lalu',
    desc: 'Lonjakan lalu lintas terenkripsi yang tidak biasa terdeteksi di dekat infrastruktur vital.',
  },
  {
    id: 'ALT-002',
    type: 'WASPADA',
    source: 'HUMINT',
    location: 'Papua',
    time: '15 mnt lalu',
    desc: 'Laporan belum terkonfirmasi mengenai pergerakan kelompok bersenjata di Sektor 4.',
  },
  {
    id: 'ALT-003',
    type: 'INFO',
    source: 'SIBER',
    location: 'Nasional',
    time: '1 jam lalu',
    desc: 'Pemindaian port rutin terdeteksi dari blok IP eksternal.',
  },
  {
    id: 'ALT-004',
    type: 'KRITIS',
    source: 'OSINT',
    location: 'Jawa Barat',
    time: '2 jam lalu',
    desc: 'Koordinasi pengumpulan massa terdeteksi di forum dark web.',
  },
]

export const usersList = [
  {
    id: 'SA-001',
    username: 'admin.nasional',
    name: 'Jenderal Budi',
    role: 'Super Admin Nasional',
    region: 'Nasional',
    status: 'Aktif',
    lastLogin: '2023-10-27 08:00',
    unit: 'Markas Besar',
    device: 'DEV-001',
    email: 'budi@bimcs.go.id',
    joined: '2020-01-15',
  },
  {
    id: 'ADM-001',
    username: 'admin.ops',
    name: 'Kolonel Andi',
    role: 'Administrator Nasional',
    region: 'Nasional',
    status: 'Aktif',
    lastLogin: '2023-10-27 09:15',
    unit: 'Operasi Nasional',
    device: 'DEV-002',
    email: 'andi@bimcs.go.id',
    joined: '2021-03-10',
  },
  {
    id: 'KB-SU',
    username: 'kb.sumut',
    name: 'Brigjen Daud',
    role: 'Kepala BINDA',
    region: 'Sumatera Utara',
    status: 'Aktif',
    lastLogin: '2023-10-27 10:30',
    unit: 'BINDA Sumut',
    device: 'DEV-003',
    email: 'daud@bimcs.go.id',
    joined: '2019-11-20',
  },
  {
    id: 'KB-RI',
    username: 'kb.riau',
    name: 'Brigjen Rizal',
    role: 'Kepala BINDA',
    region: 'Riau',
    status: 'Aktif',
    lastLogin: '2023-10-27 07:45',
    unit: 'BINDA Riau',
    device: 'DEV-004',
    email: 'rizal@bimcs.go.id',
    joined: '2020-05-05',
  },
  {
    id: 'WKB-JB',
    username: 'wkb.jabar',
    name: 'Kolonel Dedi',
    role: 'Wakil Kepala BINDA',
    region: 'Jawa Barat',
    status: 'Aktif',
    lastLogin: '2023-10-25 14:20',
    unit: 'BINDA Jabar',
    device: 'DEV-005',
    email: 'dedi@bimcs.go.id',
    joined: '2022-02-18',
  },
  {
    id: 'AB-JB',
    username: 'admin.jabar',
    name: 'Mayor Cipto',
    role: 'Admin BINDA',
    region: 'Jawa Barat',
    status: 'Aktif',
    lastLogin: '2023-10-27 08:30',
    unit: 'BINDA Jabar',
    device: 'DEV-006',
    email: 'cipto@bimcs.go.id',
    joined: '2021-08-22',
  },
  {
    id: 'AN-HQ',
    username: 'analis.hq',
    name: 'Kapten Rina',
    role: 'Analis',
    region: 'Nasional',
    status: 'Aktif',
    lastLogin: '2023-10-27 09:45',
    unit: 'Pusat Analisis',
    device: 'DEV-007',
    email: 'rina@bimcs.go.id',
    joined: '2023-01-10',
  },
  {
    id: 'AN-JB',
    username: 'analis.jabar',
    name: 'Lettu Bayu',
    role: 'Analis',
    region: 'Jawa Barat',
    status: 'Aktif',
    lastLogin: '2023-10-27 10:15',
    unit: 'BINDA Jabar',
    device: 'DEV-008',
    email: 'bayu@bimcs.go.id',
    joined: '2023-04-05',
  },
  {
    id: 'KW-JB',
    username: 'koor.jabar',
    name: 'Kapten Surya',
    role: 'Koordinator Wilayah',
    region: 'Jawa Barat',
    status: 'Aktif',
    lastLogin: '2023-10-27 11:00',
    unit: 'BINDA Jabar',
    device: 'DEV-009',
    email: 'surya@bimcs.go.id',
    joined: '2022-09-12',
  },
  {
    id: 'OP-CC',
    username: 'op.cc.1',
    name: 'Sersan Tejo',
    role: 'Operator Command Center',
    region: 'Nasional',
    status: 'Aktif',
    lastLogin: '2023-10-27 07:30',
    unit: 'Command Center',
    device: 'DEV-010',
    email: 'tejo@bimcs.go.id',
    joined: '2021-12-01',
  },
  {
    id: 'PL-001',
    username: 'agen.alpha',
    name: 'Agen Alpha',
    role: 'Personel Lapangan',
    region: 'DKI Jakarta',
    status: 'Aktif',
    lastLogin: '2023-10-27 06:00',
    unit: 'Operasi Lapangan',
    device: 'DEV-011',
    email: 'alpha@bimcs.go.id',
    joined: '2023-06-15',
  },
]

export const kpiDataList = [
  {
    name: 'DKI Jakarta',
    kode: 'BINDA-JK',
    score: 98,
    reports: 145,
    responseTime: '12m',
  },
  {
    name: 'Jawa Barat',
    kode: 'BINDA-JB',
    score: 95,
    reports: 132,
    responseTime: '15m',
  },
  {
    name: 'Jawa Timur',
    kode: 'BINDA-JI',
    score: 92,
    reports: 118,
    responseTime: '18m',
  },
  {
    name: 'Bali',
    kode: 'BINDA-BA',
    score: 89,
    reports: 85,
    responseTime: '22m',
  },
  {
    name: 'Papua',
    kode: 'BINDA-PA',
    score: 85,
    reports: 64,
    responseTime: '28m',
  },
]

export const auditLogList = [
  {
    id: 'LOG-2023-1000',
    timestamp: '2023-10-27 15:00:00',
    actor: 'admin.nasional',
    role: 'Super Admin',
    category: 'Manajemen Pengguna',
    action: 'Buat Pengguna',
    detail: 'Membuat akun baru untuk analis.jabar',
    target: 'AN-JB',
    ipAddress: '192.168.1.100',
    result: 'Berhasil',
  },
  {
    id: 'LOG-2023-1001',
    timestamp: '2023-10-27 14:30:00',
    actor: 'admin.nasional',
    role: 'Super Admin',
    category: 'Aktivitas Login',
    action: 'Otentikasi Berhasil',
    detail: 'Login berhasil dengan MFA',
    target: '-',
    ipAddress: '192.168.1.100',
    result: 'Berhasil',
  },
  {
    id: 'LOG-2023-1002',
    timestamp: '2023-10-27 14:15:22',
    actor: 'analis.hq',
    role: 'Analis',
    category: 'Aktivitas Verifikasi',
    action: 'Verifikasi Laporan',
    detail: 'Memverifikasi laporan kejadian keamanan',
    target: 'REP-2023-001',
    ipAddress: '10.0.5.22',
    result: 'Berhasil',
  },
  {
    id: 'LOG-2023-1003',
    timestamp: '2023-10-27 13:45:10',
    actor: 'op.cc.1',
    role: 'Operator',
    category: 'Aktivitas Verifikasi',
    action: 'Eskalasi Peringatan',
    detail: 'Menaikkan tingkat peringatan ke KRITIS',
    target: 'ALT-001',
    ipAddress: '10.0.2.15',
    result: 'Berhasil',
  },
  {
    id: 'LOG-2023-1004',
    timestamp: '2023-10-27 12:30:05',
    actor: 'admin.jabar',
    role: 'Admin BINDA',
    category: 'Manajemen Pengguna',
    action: 'Ubah Peran Pengguna',
    detail: 'Mengubah peran dari Personel ke Analis',
    target: 'USR-005',
    ipAddress: '192.168.2.50',
    result: 'Berhasil',
  },
  {
    id: 'LOG-2023-1005',
    timestamp: '2023-10-27 11:15:00',
    actor: 'unknown',
    role: '-',
    category: 'Aktivitas Login',
    action: 'Otentikasi Gagal',
    detail: 'Kata sandi salah 3 kali berturut-turut',
    target: 'admin.nasional',
    ipAddress: '203.0.113.45',
    result: 'Gagal',
  },
  {
    id: 'LOG-2023-1006',
    timestamp: '2023-10-27 10:45:30',
    actor: 'personel.lapangan1',
    role: 'Personel',
    category: 'Perubahan Laporan',
    action: 'Buat Laporan',
    detail: 'Membuat draf laporan patroli rutin',
    target: 'REP-2023-004',
    ipAddress: '114.125.22.10',
    result: 'Berhasil',
  },
  {
    id: 'LOG-2023-1007',
    timestamp: '2023-10-27 10:20:15',
    actor: 'kepala.binda.jabar',
    role: 'Kepala BINDA',
    category: 'Aktivitas Pengguna',
    action: 'Akses Data',
    detail: 'Melihat profil detail personel',
    target: 'USR-012',
    ipAddress: '10.0.8.100',
    result: 'Berhasil',
  },
  {
    id: 'LOG-2023-1007-A',
    timestamp: '2023-10-27 10:15:00',
    actor: 'admin.nasional',
    role: 'Super Admin',
    category: 'Manajemen Pengguna',
    action: 'Hapus Pengguna',
    detail: 'Menghapus akun pengguna yang tidak aktif',
    target: 'USR-099',
    ipAddress: '192.168.1.100',
    result: 'Berhasil',
  },
  {
    id: 'LOG-2023-1008',
    timestamp: '2023-10-27 09:55:40',
    actor: 'admin.nasional',
    role: 'Super Admin',
    category: 'Tindakan Administratif',
    action: 'Ubah Master Data',
    detail: 'Menambahkan kategori laporan baru: Siber',
    target: 'MD-KAT-004',
    ipAddress: '192.168.1.100',
    result: 'Berhasil',
  },
  {
    id: 'LOG-2023-1009',
    timestamp: '2023-10-27 09:10:05',
    actor: 'analis.hq',
    role: 'Analis',
    category: 'Perubahan Laporan',
    action: 'Ubah Status',
    detail: 'Mengubah status laporan menjadi Ditindaklanjuti',
    target: 'REP-2023-003',
    ipAddress: '10.0.5.22',
    result: 'Berhasil',
  },
  {
    id: 'LOG-2023-1010',
    timestamp: '2023-10-27 08:30:00',
    actor: 'op.cc.2',
    role: 'Operator',
    category: 'Aktivitas Login',
    action: 'Sesi Berakhir',
    detail: 'Sesi habis karena tidak ada aktivitas (timeout)',
    target: '-',
    ipAddress: '10.0.2.16',
    result: 'Peringatan',
  },
  {
    id: 'LOG-2023-1011',
    timestamp: '2023-10-26 23:45:12',
    actor: 'system',
    role: 'System',
    category: 'Tindakan Administratif',
    action: 'Pencadangan Data',
    detail: 'Pencadangan basis data harian otomatis',
    target: 'DB-MAIN',
    ipAddress: '127.0.0.1',
    result: 'Berhasil',
  },
  {
    id: 'LOG-2023-1012',
    timestamp: '2023-10-26 22:15:30',
    actor: 'personel.lapangan2',
    role: 'Personel',
    category: 'Perubahan Laporan',
    action: 'Hapus Laporan',
    detail: 'Menghapus draf laporan yang dibatalkan',
    target: 'REP-DRAFT-099',
    ipAddress: '114.125.22.15',
    result: 'Berhasil',
  },
  {
    id: 'LOG-2023-1013',
    timestamp: '2023-10-26 21:05:45',
    actor: 'analis.hq',
    role: 'Analis',
    category: 'Ekspor Data',
    action: 'Unduh Data',
    detail: 'Mengekspor data KPI Nasional ke CSV',
    target: 'KPI-NASIONAL',
    ipAddress: '10.0.5.22',
    result: 'Berhasil',
  },
  {
    id: 'LOG-2023-1014',
    timestamp: '2023-10-26 20:30:00',
    actor: 'admin.papua',
    role: 'Admin BINDA',
    category: 'Aktivitas Verifikasi',
    action: 'Konfirmasi Peringatan',
    detail: 'Gagal mengonfirmasi peringatan karena izin tidak cukup',
    target: 'ALT-005',
    ipAddress: '192.168.3.50',
    result: 'Gagal',
  },
  {
    id: 'LOG-2023-1015',
    timestamp: '2023-10-26 19:15:20',
    actor: 'kepala.binda.papua',
    role: 'Kepala BINDA',
    category: 'Aktivitas Login',
    action: 'Otentikasi Berhasil',
    detail: 'Login berhasil via biometrik',
    target: '-',
    ipAddress: '10.0.9.100',
    result: 'Berhasil',
  },
  {
    id: 'LOG-2023-1016',
    timestamp: '2023-10-26 18:45:10',
    actor: 'op.cc.1',
    role: 'Operator',
    category: 'Aktivitas Pengguna',
    action: 'Navigasi',
    detail: 'Mengakses modul Peta Operasi Nasional',
    target: 'MOD-PETA',
    ipAddress: '10.0.2.15',
    result: 'Berhasil',
  },
  {
    id: 'LOG-2023-1017',
    timestamp: '2023-10-26 17:30:05',
    actor: 'admin.nasional',
    role: 'Super Admin',
    category: 'Perubahan Sistem',
    action: 'Ubah Pengaturan',
    detail: 'Mengubah batas waktu sesi menjadi 30 menit',
    target: 'SET-SEC-01',
    ipAddress: '192.168.1.100',
    result: 'Berhasil',
  },
  {
    id: 'LOG-2023-1018',
    timestamp: '2023-10-26 16:15:00',
    actor: 'personel.lapangan1',
    role: 'Personel',
    category: 'Perubahan Laporan',
    action: 'Edit Laporan',
    detail: 'Menambahkan lampiran foto ke laporan',
    target: 'REP-2023-001',
    ipAddress: '114.125.22.10',
    result: 'Berhasil',
  },
  {
    id: 'LOG-2023-1019',
    timestamp: '2023-10-26 15:45:30',
    actor: 'analis.hq',
    role: 'Analis',
    category: 'Aktivitas Verifikasi',
    action: 'Tolak Laporan',
    detail: 'Menolak laporan karena data tidak lengkap',
    target: 'REP-2023-005',
    ipAddress: '10.0.5.22',
    result: 'Peringatan',
  },
  {
    id: 'LOG-2023-1020',
    timestamp: '2023-10-26 14:20:15',
    actor: 'unknown',
    role: '-',
    category: 'Aktivitas Login',
    action: 'Akses Ditolak',
    detail: 'Percobaan akses dari IP yang diblokir',
    target: '-',
    ipAddress: '198.51.100.22',
    result: 'Gagal',
  },
]

export const reportTypesList = [
  {
    id: 'JT-01',
    type: 'Kejadian',
    description: 'Laporan insiden atau kejadian di lapangan',
    sla: '15 menit',
    status: 'Aktif',
  },
  {
    id: 'JT-02',
    type: 'Informasi',
    description: 'Informasi intelijen umum',
    sla: '60 menit',
    status: 'Aktif',
  },
  {
    id: 'JT-03',
    type: 'Darurat',
    description: 'Situasi darurat yang membutuhkan respons segera',
    sla: '5 menit',
    status: 'Aktif',
  },
  {
    id: 'JT-04',
    type: 'Harian',
    description: 'Laporan rutin harian',
    sla: '24 jam',
    status: 'Aktif',
  },
  {
    id: 'JT-05',
    type: 'Cepat',
    description: 'Laporan cepat tanpa detail lengkap',
    sla: '10 menit',
    status: 'Aktif',
  },
]

export const alertTypesList = [
  {
    id: 'AT-01',
    type: 'KRITIS',
    description: 'Ancaman langsung terhadap keamanan nasional',
    autoEscalate: 'Ya',
    color: 'Destruktif',
  },
  {
    id: 'AT-02',
    type: 'WASPADA',
    description: 'Potensi ancaman tinggi, perlu pemantauan ketat',
    autoEscalate: 'Ya',
    color: 'Siaga',
  },
  {
    id: 'AT-03',
    type: 'PERHATIAN',
    description: 'Aktivitas mencurigakan, perlu verifikasi',
    autoEscalate: 'Tidak',
    color: 'Info',
  },
  {
    id: 'AT-04',
    type: 'INFO',
    description: 'Informasi operasional standar',
    autoEscalate: 'Tidak',
    color: 'Aktif',
  },
]

export const kpiSettingsList = [
  {
    id: 'KPI-01',
    metric: 'Waktu Respons',
    weight: 30,
    target: '< 15 menit',
    threshold: '30 menit',
  },
  {
    id: 'KPI-02',
    metric: 'Tingkat Verifikasi',
    weight: 25,
    target: '> 95%',
    threshold: '85%',
  },
  {
    id: 'KPI-03',
    metric: 'Volume Laporan',
    weight: 20,
    target: '> 100/hari',
    threshold: '50/hari',
  },
  {
    id: 'KPI-04',
    metric: 'Akurasi Intelijen',
    weight: 25,
    target: '> 98%',
    threshold: '90%',
  },
]

export const userRolesList = [
  {
    id: 'ROLE-01',
    role: 'Super Admin Nasional',
    clearance: 5,
    usersCount: 12,
    access: 'Akses penuh ke semua modul dan pengaturan',
  },
  {
    id: 'ROLE-02',
    role: 'Operator Command Center',
    clearance: 4,
    usersCount: 45,
    access: 'Akses pemantauan dan eskalasi peringatan',
  },
  {
    id: 'ROLE-03',
    role: 'Personel Lapangan',
    clearance: 2,
    usersCount: 1248,
    access: 'Akses pelaporan dan penerimaan instruksi',
  },
  {
    id: 'ROLE-04',
    role: 'Analis',
    clearance: 4,
    usersCount: 86,
    access: 'Akses verifikasi dan analisis data intelijen',
  },
  {
    id: 'ROLE-05',
    role: 'Kepala BINDA',
    clearance: 5,
    usersCount: 38,
    access: 'Akses eksekutif wilayah dan persetujuan',
  },
  {
    id: 'ROLE-06',
    role: 'Admin BINDA',
    clearance: 4,
    usersCount: 76,
    access: 'Manajemen pengguna dan data tingkat wilayah',
  },
]

export const systemParamsList = [
  {
    id: 'SYS-01',
    parameter: 'Batas Waktu Sesi',
    value: '30',
    unit: 'Menit',
    description: 'Waktu sebelum sesi pengguna otomatis berakhir',
  },
  {
    id: 'SYS-02',
    parameter: 'Maks. Ukuran Lampiran',
    value: '50',
    unit: 'MB',
    description: 'Ukuran maksimal file yang dapat diunggah',
  },
  {
    id: 'SYS-03',
    parameter: 'Retensi Log',
    value: '365',
    unit: 'Hari',
    description: 'Lama waktu log audit disimpan di sistem',
  },
  {
    id: 'SYS-04',
    parameter: 'Interval Sinkronisasi',
    value: '5',
    unit: 'Detik',
    description: 'Jeda waktu pembaruan data real-time',
  },
  {
    id: 'SYS-05',
    parameter: 'Tingkat DEFCON Default',
    value: '3',
    unit: 'Level',
    description: 'Tingkat kewaspadaan standar sistem',
  },
]

export const notificationsList = [
  {
    id: 'NOTIF-001',
    type: 'Laporan baru',
    title: 'Laporan Intelijen Baru',
    message: 'Laporan kejadian keamanan diterima dari Sektor 4 (DKI Jakarta).',
    time: '5 menit yang lalu',
    isRead: false,
    link: '/reports/REP-2023-001',
  },
  {
    id: 'NOTIF-002',
    type: 'Butuh verifikasi',
    title: 'Verifikasi Analis Diperlukan',
    message: 'Terdapat 3 laporan informasi yang menunggu verifikasi Anda.',
    time: '12 menit yang lalu',
    isRead: false,
    link: '/reports',
  },
  {
    id: 'NOTIF-003',
    type: 'Peringatan kritis',
    title: 'Peringatan Kritis: Anomali Siber',
    message:
      'Lonjakan lalu lintas terenkripsi yang tidak biasa terdeteksi di dekat infrastruktur vital.',
    time: '30 menit yang lalu',
    isRead: false,
    link: '/alerts/ALT-001',
  },
  {
    id: 'NOTIF-004',
    type: 'Pembaruan KPI',
    title: 'Target KPI Tercapai',
    message:
      'Rata-rata waktu respons penanganan di Jawa Barat telah mencapai target (< 15 menit).',
    time: '2 jam yang lalu',
    isRead: true,
    link: '/kpi/BINDA-JB',
  },
  {
    id: 'NOTIF-005',
    type: 'Peringatan sistem',
    title: 'Pemeliharaan Sistem Terjadwal',
    message:
      'Pusat data utama akan menjalani pemeliharaan rutin pada pukul 02:00 WIB.',
    time: '1 hari yang lalu',
    isRead: true,
    link: '/settings',
  },
]
